export enum enmDirection {
  UP = 1,
  DOWN = 2,
  RIGHT = 3,
  LEFT = 4,
}
